import { defineMessages } from "react-intl";

export const scope = "components.DepositPersonalAccountArs";

export const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Datos de tu cuenta personal",
  },
  paymentNetwork: {
    id: `${scope}.paymentNetwork`,
    defaultMessage: "Red de pago",
  },
  yourAlias: {
    id: `${scope}.yourAlias`,
    defaultMessage: "Tu alias",
  },
  aliasLb: {
    id: `${scope}.aliasLb`,
    defaultMessage: "Alias de LB Finanzas",
  },
  yourCvu: {
    id: `${scope}.yourCvu`,
    defaultMessage: "Tu CVU",
  },
  CbuLb: {
    id: `${scope}.CbuLb`,
    defaultMessage: "CBU de LB Finanzas",
  },
  currencyToReceive: {
    id: `${scope}.currencyToReceive`,
    defaultMessage: "Moneda a recibir",
  },
  copy: {
    id: `${scope}.copy`,
    defaultMessage: "COPIAR",
  },
  alertSign: {
    id: `${scope}.alertSign`,
    defaultMessage:
      "Todos tus depósitos no podrán superar los { amount } { currency } mensuales.",
  },
});
